<template>
  <div class="container">
      <a-modal class="" title="新增监测点位" :visible="publicVisible"  @cancel="closeVisible"  width="70%" @ok="submit" >
        <div>

              <a-form-model :model="categoryList" ref="categoryListRef" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 3 }" class="model_span_form" :wrapper-col="{ span: 21 }"
                            label="检测类别"  prop="pollutantTypeId"  :rules="{
								  required: true,
								  message: '请填写检测类别',
								  trigger: 'change',
								}">
                              <span v-if="type == 0">{{categoryList.pollutantName}}</span>
                              <a-select v-if="type == 1" allowClear placeholder="请选择检测类别"  v-model="categoryList.pollutantTypeId" @change="changeProject">
                                      <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                                          {{ item.pollutantName }}
                                    </a-select-option>
                          </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
    <div>
            <div class="projectContainer">
                <span>项目列表</span>
                 <a-button type="primary" @click="addCategory" style="margin-right: 5px">新增</a-button>
            </div>
            <div>
                  <a-table :data-source="projectList" bordered :loading="loading" :pagination="false" 
				             :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
                             <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                                  <template scope="text, record, index">
                                    {{index + 1 }}
                                  </template>
				             </a-table-column>
				             <a-table-column key="item" title="检测项目" ellipsis="true" data-index="item" />
				             <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
				             <a-table-column key="pointNumber" title="点位数" ellipsis="true" data-index="pointNumber">
                             <template slot-scope="text, record">
                               <a-input v-model="record.pointNumber" placeholder="请输入" @change="changePrice(record)"></a-input>
							</template>
                            </a-table-column>
				            <a-table-column key="totalPrice" title="小计" ellipsis="true" data-index="totalPrice" >
                            <template slot-scope="text, record">
                               <a-input v-model="record.totalPrice" placeholder="请输入"></a-input>
							</template>
                            </a-table-column>
				            <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                            <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                             <a-table-column title="操作" width="100px">
					            <template scope="text,record">
                                   <a @click="deleteProject(record)">删除</a>
                                </template>
                             </a-table-column>
                         </a-table>
            </div>
        </div> 
     </a-modal>
     <AddProject  :addProjectVisible="addProjectVisible " @changeProjectVisible="changeProjectVisible" :addProjectList="addProjectList" :ids="ids" @reshProjectList="getProjectList"></AddProject>
 <!-- 表格计算弹窗 -->
     <!-- <div>
         
      <a-modal  title="请填写频次" :visible="countVisible"  @cancel="closeCount"  width="40%" @ok="submitCount" >
        <div>
            <span>{{ tableData.item}}</span>
        </div>
        <div>
            <a-input v-model="number" placeholder="请输入"></a-input> * <a-input v-model="day" placeholder="请输入"></a-input>
        </div>
      </a-modal>

     </div> -->
   
  
  </div>
</template>

<script>
import AddProject from './addProject.vue'
import {getPollotantList, getPollutantTypeList,addPointInfo, testItemList, getPollutantInfo, editPointInfo, pointInfoList, getTestItemByPointId, editBatch, getQuoteRelationFactorList, deleteItems} from '@/api/surrounding'
export default {
    components: {
        AddProject
  },
      props: [
        'publicVisible',
        'rowData',
        'UUID',
        'itemList',
        'environmentList',
        'index',
        'enviromentList',
        'categoryList',
        'projectList',
        'datalist',
        'type',
        'recordData'
    ],
    data() {
        return {
            day: 0,
            number: 0,
            itemdata: {},
            // categoryList: {
            //     pointId: ''
            // },
            // projectList: [],
            scroll_y: 150,
            // datalist: [],
            addProjectVisible: false,
            // 新增项目列表
            addProjectList: [],
            ids: {},
            countVisible: false,
            tableData: {}
        }
    },
    created() {
        // getPollutantTypeList({
        //     projectId: this.rowData.id
        // }).then(res => {
        //     if(res.code == 200) {
        //         console.log(res, 'res==============================')
        //         this.datalist = res.data.list
        //     } else {
        //         this.$message.err(res.msg)
        //     }
        // })
        // //获得项目列表
        // this.getProjectList()

    },
    methods: {
        changeProject(e) {
            console.log(e,'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
        },
        
        //获取第二步列表数据
        getEnvironmentList() {
            
             pointInfoList({
                sheetId: this.UUID,
                subId: this.itemList.id,
                // pollutantTypeId: this.categoryList.pollutantTypeId
                // pointId:  this.categoryList.pointId,

            }).then (res => {
                if(res.code == 200) {
                    console.log(res.data.list, 'res.data.listres.data.listres.data.list')
                    // Object.assign(this.environmentList[this.index], {environmentList:res.data.list})
                    this.$emit('refreshList',res.data.list)
                    
                } else {
                    this.$message.error(res.msg)
                }


            })
        },

        //价格变化事件
        changePrice(record) {
            record.totalPrice = record.pointNumber *  record.price * 3
        },
        // 频次弹窗提交事件
        submitCount() {
            this.tableData.frequence = this.day * this.number
            this.countVisible = false
            console.log( this.tableData, ' this.tableData==================')


        },
        closeCount() {
              this.countVisible = false

        },
        //频次
        changeFrequence(text, record, index) {
            console.log(text, record, index, '111111111111111111111')
            // document.getElementById("fname").style.backgroundColor = "red";
            console.log('333333333333333333333333')
            this.countVisible = true
            this.tableData = record

            console.log(record, 'record======================')

        },
        // 提交事件
        submit() {
            console.log(this.projectList, 'projectList=======================')
            this.projectList.forEach(item => {
                  Object.assign( item, {
                     sheetId: this.UUID,
                subId: this.itemList.id,
                // pointId:  this.categoryList.pointId,
                pollutantTypeId: this.categoryList.pollutantTypeId,
                pollutantName: item.item

                // pollutantName: item.item

            })

            })
            if (this.type == 0) {
                 this.projectList.forEach(item => {
                  Object.assign( item, {
                pointId:  this.recordData.id,
            })

            })
                  editBatch({
                quoteTestItemDTOList: this.projectList

            }).then (res => {
                console.log(res.data)
                if(res.code == 200) {
                    this.getEnvironmentList()
                    this.categoryList = {}
                    this.projectList = []
                    
                    this.publicVisible = false
                    this.$emit('changePublicVisible',this.publicVisible )

                } else {
                    this.$message.error(res.msg)
                }

            })

            } else {

          
          
            editBatch({
                quoteTestItemDTOList: this.projectList

            }).then (res => {
                console.log(res.data)
                if(res.code == 200) {
                    this.getEnvironmentList()
                    
                    this.publicVisible = false
                    this.$emit('changePublicVisible',this.publicVisible )

                } else {
                    this.$message.error(res.msg)
                }

            })
              }

        },
        //获得项目列表
        getProjectList() {
           
            getTestItemByPointId({
                sheetId: this.UUID,
                subId: this.itemList.id,
                pointId:  this.categoryList.pointId,
                pollutantTypeId: this.categoryList.pollutantTypeId

            }).then (res => {
                if(res.code == 200) {
                    this.projectList = res.data
                } else {
                    this.$message.error(res.msg)
                }


            })

        },
        changeProjectVisible(data) {
            this.addProjectVisible = data

        },
        //关闭弹窗
        closeVisible() {
            this.categoryList = {}
            this.projectList = []
            this.publicVisible = false
            this.$emit('changePublicVisible',this.publicVisible )

        },
        //删除报价检测项目
        deleteProject(record) {
            console.log(record, 'recordrecordrecordrecord')
            deleteItems(record.id).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                    //刷新页面
                    this.getProjectList()
                } else {
                    this.$message.error(res.msg)
                }

            })

        },
        //新增事件
        addCategory() {
            console.log(this.ids, 'this.idsthis.idsthis.ids======')
              Object.assign(this.ids, {
                          // 主类id
                        masterCategoryId: this.enviromentList[this.index].masterCategoryId,
                        // 检测类别id
                        pollutantTypeId: this.categoryList.pollutantTypeId,
                        // 表单id
                        sheetId: this.UUID,
                        // 子类id
                        subId: this.enviromentList[this.index].id
                    })
            console.log( this.enviromentList[this.index], ' this.enviromentList[this.index].subId')
              this.$refs.categoryListRef.validate((valid) => {
                if(valid) {
                    console.log('11111111111111111111111111111111')
                    getQuoteRelationFactorList({
                   
                        // subId: this.enviromentList[this.index].subId,
                        // 主类id
                        masterCategoryId: this.enviromentList[this.index].masterCategoryId,
                        // 检测类别id
                        pollutantTypeId: this.categoryList.pollutantTypeId,
                        // 表单id
                        sheetId: this.UUID,
                        // 子类id
                        subId: this.enviromentList[this.index].id
                        

                     

                    }).then(res => {
                        if(res.code == 200) {
                            this.addProjectList = res.data.list
                           this.addProjectVisible = true
                        }else {
                            this.$message.error(res.msg)
                        }

                    })

                }
              })


        }

    }

}
</script>

<style>
.projectContainer {
    display: flex;
    justify-content: space-between;
    margin: 10px 20px;
    /* display: flex;
    justify-content: space-between; */
}

</style>